/* eslint-disable */
import { Empty } from 'antd';
import React, { FC, useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ApplicationCommonErrors from '~/components/views/ApplicationCommonErrors';
import features from '~/constants/features';
import { useGetApplication, useGetPayloadWithProvided, useSelectStep } from '~/controllers/wizard';
import WizardNavigation from '~/layouts/WizardNavigation';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import paths from '~/pages/paths';
import { getStagePayload } from '~/utils/getStagePayload';
import { getDecodedJwt, isAgent, isNogoManager } from '~/utils/getDecodedJwt';
import { useTranslation } from 'react-i18next';
import { Stage } from '~/types/Application';
import CompleteReviewRightContent from '~/pages/ksa/review/completeReview/components/CompleteReviewRightContent';
import { get, isEmpty } from 'lodash';
import { fallbackSteps } from '~/pages/ksa/review/fallbacksteps';
import AgentActivityLogPanel from '~/pages/ksa/review/components/AgentActivityLogPanel';
import Merchant from './merchant';
import ScreeningResult from './screeningResult';
import CompanyInformation from './companyInformation';
import Address from './address';
import CompanyQuestionnaire from './companyQuestionnaire';
import Managers from './managers';
import BankAccount from './bankAccount';
import Shareholders from './shareholders';
import CompleteReview from './completeReview';
import { useHistory } from 'react-router';
import AgentContractView from '~/pages/ksa/contract/AgentContractView';

const views: Record<string, React.ComponentType> = {
  screeningResult: ScreeningResult,
  companyInformation: CompanyInformation,
  address: Address,
  companyQuestionnaire: CompanyQuestionnaire,
  managers: Managers,
  bankAccount: BankAccount,
  shareholders: Shareholders,
  completeReview: CompleteReview,
  contractReview: AgentContractView,
};

const Review: FC<void> = () => {
  const location = useLocation();
  const applicationQuery = useGetApplication();
  const selectStep = useSelectStep();
  const history = useHistory();
  const payload = useGetPayloadWithProvided();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const reviewSteps: any = stagePayload?.steps.find((item) => item.key === 'review')?.steps;

  useEffect(() => {
    if (
      applicationQuery.data?.stage !== 'ksaReview' &&
      applicationQuery.data?.stage !== 'ksaApplication' &&
      !applicationQuery?.isLoading
    ) {
      selectStep.mutate({ stageKey: 'ksaReview', stepKey: 'review.screeningResult' });
      history.push('/ksa/review/screeningResult');
    }
  }, [applicationQuery?.isLoading]);

  const { t } = useTranslation('fillApplication');
  const isCompleteReview = location.pathname.includes('completeReview');
  const isAgentSubmmitedApp = !!applicationQuery?.data?.payload?.completeReview?.length;

  const automatedScreening = payload?.reviewScreeningResult?.automated;
  const latestAutomatedScreeningResolution =
    automatedScreening &&
    !isEmpty(automatedScreening) &&
    automatedScreening[automatedScreening.length - 1]?.resolution;
  const isAutomatedScreeningInProgress =
    latestAutomatedScreeningResolution === 'IN_PROGRESS' ||
    latestAutomatedScreeningResolution === 'MANUAL';

  if (!isAgent() && !isNogoManager()) {
    return <Merchant />;
  }

  return (
    <WizardContent
      left={
        <LeftLayout>
          <WizardNavigation
            stageKey={Stage.ksaReview}
            rootPath={paths.ksa.review}
            rootStep="review"
          />
        </LeftLayout>
      }
      content={
        <>
          {(reviewSteps?.[0] && paths.ksa.review === location.pathname) ||
            (paths.ksa.review === location.pathname && (
              <Redirect
                exact
                from={paths.ksa.review}
                to={`${paths.ksa.review}/${reviewSteps?.[0].pathKey}`}
              />
            ))}
          {reviewSteps?.map((item: any) => {
            if (item.state === 'HIDDEN') return null;
            return (
              <Route
                key={item.key}
                path={`${paths.ksa.review}/${item.pathKey}` as any as string}
                component={views[item.pathKey] || Empty}
              />
            );
          })}
          {!location.pathname.includes('contractReview') && (
            <WizardContinueButton
              id="reviewSteps_continueButton"
              formName={location.pathname}
              disabled={
                isAgentSubmmitedApp &&
                !(
                  applicationQuery.data?.stage === Stage.ksaContract &&
                  location?.pathname.includes('companyInformation')
                )
              }
            >
              {t('Submit')}
            </WizardContinueButton>
          )}
        </>
      }
      right={<AgentActivityLogPanel />}
    />
  );
};

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
  width: 70%;

  .upperContainer {
    height: 100%;
  }

  .WizardContinueButton,
  .NoteText {
    margin-top: 24px;
  }
`;

export default Review;
